module.exports = __webpack_public_path__ + "img/1574178507.168b3b65.jpg";